import { type Permission } from "@alch/dx-entities";
import { logException } from "@util/errors.js";
import useCurrentUser from "./useCurrentUser.js";

const useHasPermission = (permission: Permission): boolean => {
  const { data: currentUser } = useCurrentUser();

  // currentUser is always defined here: AuthedRoot blocks rendering until
  // useCurrentUser resolves. This guard should never be hit.
  if (!currentUser) {
    logException(new Error("useHasPermission called without currentUser"));
    return false;
  }

  return currentUser.permissions.includes(permission);
};

export default useHasPermission;
